/**
 * Desktop drawer header: brand wordmark plus the icon-rail toggle.
 * Rail mode drops the wordmark (the app header shows it instead) and centers
 * an expand chevron. Update when changing rail toggle affordances.
 */
import React from 'react';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { IconButton, Toolbar, Tooltip } from '@mui/material';

import { LogoText } from './LogoHeader';

interface DrawerHeaderProps {
  rail: boolean;
  onToggleRail: () => void;
}

const DrawerHeader = ({ rail, onToggleRail }: DrawerHeaderProps) => {
  const toggleLabel = rail ? 'Expand navigation' : 'Collapse navigation';

  return (
    <Toolbar
      sx={{
        mb: 2,
        justifyContent: rail ? 'center' : 'space-between',
        px: rail ? 1 : 2,
      }}
      disableGutters
    >
      {!rail && (
        <LogoText variant="h6" component="p">
          DeepThink
        </LogoText>
      )}
      <Tooltip title={`${toggleLabel} (⌘/Ctrl + \\)`} placement="right">
        <IconButton
          onClick={onToggleRail}
          aria-label={toggleLabel}
          size="small"
          sx={{ color: 'text.secondary' }}
        >
          {rail ? <ChevronRight /> : <ChevronLeft />}
        </IconButton>
      </Tooltip>
    </Toolbar>
  );
};

export default DrawerHeader;
